module.exports = "https://static.wanderu.com/static/media/iphone-carriers.6b75cd37.png";